import { FC, ReactNode, HTMLAttributes } from "react";

import cn from "utils/cn";

interface DrawerProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

interface DrawerComponents {
  Header: FC<DrawerHeaderProps>;
  Body: FC<DrawerBodyProps>;
  Footer: FC<DrawerFooterProps>;
}

interface DrawerHeaderProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
  title?: string;
}

interface DrawerBodyProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

interface DrawerFooterProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

const Drawer: FC<DrawerProps> & DrawerComponents = ({
  children,
  className,
  ...rest
}) => {
  return (
    <div
      className={cn(
        "flex flex-col h-full bg-[#2e2e2e] md:!w-[485px]  relative",
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
};

const DrawerHeader: FC<DrawerHeaderProps> = ({
  children,
  title,
  className,
  ...rest
}) => {
  return (
    <div
      className={cn(" z-50 sticky top-0 px-[32px] py-[24px]", className)}
      {...rest}
    >
      {children ? (
        children
      ) : (
        <p className="text-white font-bold text-xl leading-5">{title}</p>
      )}
    </div>
  );
};

const DrawerBody: FC<DrawerBodyProps> = ({ children, className, ...rest }) => {
  return (
    <div
      className={cn(
        "flex flex-col px-[32px] py-[24px] min-h-[450px] overflow-auto h-full",
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
};

const DrawerFooter: FC<DrawerFooterProps> = ({
  children,
  className,
  ...rest
}) => {
  return (
    <div
      className={cn(
        "z-50 sticky bottom-[16px] px-8 py-4 bg-[#2e2e2e] border-t border-[#484848]",
        className,
      )}
      {...rest}
    >
      <div className="flex gap-5 justify-center md:justify-end ">
        {children}
      </div>
    </div>
  );
};

Drawer.Header = DrawerHeader;
Drawer.Body = DrawerBody;
Drawer.Footer = DrawerFooter;

export default Drawer;
